import { createSelector } from '@reduxjs/toolkit';
import { selectConditionType, selectOfficeTypes } from 'shared/selectors/jsonQuery';
import { EConditionType } from '../../../../packages/JsonQuery/types/conditionType';
import { getConditionTypeFields } from '../../../../packages/JsonQuery/utils/getConditionTypeFields';

const LABELS: Record<EConditionType, string> = {
  [EConditionType.OfficeDecoration]: 'Офисная отделка',
  [EConditionType.FullDecorationNeeded]: 'Под чистовую отделку',
  [EConditionType.MajorRepairNeeded]: 'Требуется капитальный ремонт',
  [EConditionType.CosmeticRepairNeeded]: 'Требуется косметический ремонт',
  [EConditionType.RegularRepair]: 'Типовой ремонт',
  [EConditionType.DesignerRepair]: 'Дизайнерский ремонт',
  [EConditionType.WithDecoration]: 'С отделкой',
};

export const selectConditionTypeFilter = createSelector(
  [selectConditionType, selectOfficeTypes],
  (value, officeTypes) => ({
    label: 'Состояние',
    options: getConditionTypeFields(officeTypes).map(field => ({ label: LABELS[field], value: field })),
    value: value && value.length > 0 ? value : [null],
  }),
);
